<!--
  Lovi
  详情页 2020-1-7
-->
<template>
  <div class="detail-wrap" v-if="detail.label">
    <div class="info">
      <div>
        <img
          class="icon"
          :src="
            detail.icon
              ? httpUrl + detail.icon
              : require('@/assets/images/public/logo_icon@2x.png')
          "
        />
        <div class="">
          <h3>{{ detail.label }}</h3>
          <p class="text-blue">{{ detail.state_label }}</p>
        </div>
      </div>
      <div class="money">
        {{ detail.money_type == 1 ? "+" : detail.money_type == 2 ? "-" : ""
        }}{{ detail.money }}
      </div>
    </div>
    <div class="list">
      <dl v-for="(item, index) in detail.list" :key="index">
        <dt>{{ item.label }}</dt>
        <dd v-if="item.is_click">
          <a
            href="javascript:void(0)"
            class="link text-blue"
            @click="toSubOrder(item)"
          >
            {{ item.value }}
          </a>
        </dd>
        <dd v-else>
          {{ item.value === "" ? $t("common.nothing") : item.value }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type", "order_id"],
  data() {
    return {
      detail: {} // 详情页Data
    };
  },
  created() {
    if (this.order_id) {
      this._getDetail();
    }
  },
  mounted() {},
  computed: {},
  methods: {
    _getDetail() {
      // 订单详情
      let vm = this;
      let params = {};
      params.type = vm.type;
      params.order_id = vm.order_id;
      vm.$post("/app/recharge/rechargeRecordDetails", params, {
        loading: true
      }).then(res => {
        console.log("rechargeRecordDetails", res);
        vm.detail = res;
      });
    },
    toSubOrder(data) {
      // 获取子订单参数
      let vm = this;
      if (data.is_click) {
        let obj = {};
        obj.type = vm.detail.type;
        obj.status = data.status;
        obj.order_id = vm.order_id;
        obj.title = data.label;
        console.log("toSubOrder", obj);
        vm.$emit("getSubOrder", obj);
      }
    }
  },
  watch: {},
  components: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.detail-wrap {
  margin-top: 20px;
  padding: 0 50px;
  .info {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    > div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon {
        margin-right: 10px;
        width: 48px;
        height: 48px;
      }
      > div {
        h3 {
          font-size: 20px;
          font-weight: 500;
        }
        p {
          margin-top: 5px;
        }
      }
    }
    .money {
      font-size: 20px;
      font-weight: 500;
    }
  }
  .list {
    dl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      line-height: 24px;
      font-size: 14px;
      border-bottom: 1px solid #ccc;
      dt {
        margin-right: 10px;
      }
      dd {
        flex: 1;
        text-align: right;
        color: rgba(96, 96, 96, 0.6);
        a.link {
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>
